"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSetCriteria = void 0;
var DataSetCriteria = /** @class */ (function () {
    function DataSetCriteria() {
        Object.defineProperty(this, "sorts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "filters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "selects", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "includes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "search", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "from", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "to", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * PAGEABLE DATASET HELPERS
         *
         * Using these setters can provide some assistance in in working with paged
         * data by working out the `from` and `to` values for you based on the size
         * of a page and the current page number.
         */
        Object.defineProperty(this, "_pageSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_pageNumber", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 1
        });
    }
    Object.defineProperty(DataSetCriteria.prototype, "setRange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (from, to) {
            this.from = from;
            this.to = to;
        }
    });
    Object.defineProperty(DataSetCriteria.prototype, "pageSize", {
        get: function () {
            return this._pageSize;
        },
        set: function (pageSize) {
            this._pageSize = pageSize;
            this.updateRange();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataSetCriteria.prototype, "pageNumber", {
        get: function () {
            return this._pageNumber;
        },
        set: function (pageNumber) {
            this._pageNumber = pageNumber;
            this.updateRange();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataSetCriteria.prototype, "updateRange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var from = (this._pageNumber - 1) * this._pageSize;
            var to = from + this._pageSize - 1;
            this.setRange(from, to);
        }
    });
    return DataSetCriteria;
}());
exports.DataSetCriteria = DataSetCriteria;
exports.default = DataSetCriteria;
//# sourceMappingURL=DataSetCriteria.js.map